export default __webpack_public_path__ + "static/media/img7.fcf118f3.png";